import { css } from "@linaria/core";
import React from "react";
import { fonts } from "@ui";

const fontBody2 = css`
  font: ${fonts.body2SemiBold};
`;
export const FaultDescriptionChartTooltip = ({ description }: { description: string }) => (
  <p className={fontBody2}>{description}</p>
);
